import { useEffect, useState } from 'react';
import Lottie from 'react-lottie-player';
import styled from 'styled-components';

import Box from './Box';
import { Paragraph } from './Paragraph';

import loadingData from '../../../assets/lotties/loading-nova.json';
import { useResponsiveContext } from '../../../contexts/ResponsiveContext';
import lockScrollbar from '../../../utils/helpers/lockScrollbar';

const StyledMiddleBox = styled(Box)`
    position: absolute;
    width: 100vw;
    transform: translate(-50%, -50%);
    top: 50%;
    left: 50%;
    z-index: 100;
`;

const StyledParagraph = styled(Paragraph)`
    position: fixed;
    width: 70%;
    transform: translate(-50%, -50%);
    top: 65%;
    left: 50%;
    text-align: center;
`

const Backdrop = styled.div`
    width: 100%;
    height: 100%;
    position: fixed;
    z-index: -1;
    left: 0;
    top: 0;
    background-color: #ffffff;
    opacity: 0.5;
`;

type TProps = {
    description?: string;
}

const LoadingNova = ({ description }: TProps) => {
    const [pageHeight, setPageHeight] = useState(0);
    const [viewMode] = useResponsiveContext();

    const isMobile = viewMode === 'mobile';

    // Window height + scrollable height
    let pgHeight = document.body.clientHeight + (document.body.offsetHeight - window.innerHeight);

    useEffect(() => {
        setPageHeight(pgHeight);
        lockScrollbar(true);

        return () => lockScrollbar(false);

    }, [pgHeight]);

    const defaultOptions = {
        loop: true,
        play: true,
        animationData: loadingData,
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice',
        },
        style: { width: isMobile ? 'inherit' : '400px', height: '100%', margin: 'auto' }
    };

    return (
        <StyledMiddleBox height={pageHeight ? `${pageHeight}px` : 'inherit'} >
            <Lottie {...defaultOptions} />
            {description && <StyledParagraph typography='text-s-medium' customColor="black-1">{description}</StyledParagraph>}
            <Backdrop />
        </StyledMiddleBox>
    );
};

export default LoadingNova;
